<ng-container *ngIf="marketOptions$ | async as marketOptions; else loading">
  <glxy-form-field required="true">
    <glxy-label>
      {{ 'AUTOMATIONS.EDITOR.FILTERS.ACCOUNT_GROUP_DATA.DATA_LABELS.MARKET' | translate }}
    </glxy-label>
    <mat-select [formControl]="marketOptionsControl" required="true">
      <mat-option *ngFor="let market of marketOptions" [value]="market.market_id">
        {{ market.name }}
      </mat-option>
    </mat-select>
  </glxy-form-field>
</ng-container>

<ng-template #loading>
  <div class="content side-drawer-shimmer-container">
    <span class="control-container selector stencil-shimmer"></span>
  </div>
</ng-template>
